import React, { useRef, useState } from "react";

// antd
import { Skeleton } from "antd";

// components
import ConversationListCard from "./CustomerPhoneNumberCard";
import InfiniteScroll from "react-infinite-scroll-component";
import { ICONS } from "../../../../assets/icons";
import Loader from "../../../../components/commonComponents/Loader/Index";

const CustomerPhoneNumber = ({
  primaryLoading,
  loading,
  searchKey,
  conversationList,
  selectedPerson,
  onSelectPerson,
  onFavoriteClick,
  onResolvedClick,
  onConversationStarChange,
  onCloseConversation,
  count = 0,
  loadNextPage,
  favorite,
  resolved,
  contactlistLoading,
}) => {
  const conversationContainerRef = useRef();

  return (
    <div className="w-full flex-1 overflow-y-scroll  border-[var(--BG-25)]" style={{
      minWidth: "18vw"
    }}>
      <Skeleton
        rootClassName="min-w-[18.4vw] px-[1vw]"
        loading={loading}
        paragraph={{ rows: 15 }}
        active
      >
        <div
          className="w-full h-full  overflow-hidden overflow-y-scroll listScroll"
          id="scrollableDiv"
          ref={conversationContainerRef}
        >
          <InfiniteScroll
            dataLength={conversationList?.length}
            next={() => {
              if (conversationList?.length < count && !loading) loadNextPage();
            }}
            hasMore={conversationList?.length < count}
            scrollableTarget="scrollableDiv"
          >
            {conversationList?.length > 0 ? (
              conversationList?.map((item) => {
                return (
                  <div className="w-[94%] overflow-hidden" style={{
                    margin: "10px 10px 10px 10px"
                  }}>
                    <ConversationListCard
                      key={item?.to_number}
                      item={item}
                      selectedPerson={selectedPerson}
                      onSelectPerson={onSelectPerson}
                      onFavoriteClick={onFavoriteClick}
                      onResolvedClick={onResolvedClick}
                      onConversationStarChange={onConversationStarChange}
                      onCloseConversation={onCloseConversation}
                      favorite={favorite}
                      conversationList={conversationList}
                      resolved={resolved}
                    />
                  </div>
                );
              })
            ) : (
              <div className="w-full h-full flex-column items-center justify-center  mt-20" style={{width: "18.15vw"}}>
                <img src={ICONS?.emptyLoader} alt="emptyLoader" />
                <span className="new-header3 pt-20">
                  You have no conversations
                </span>
                <span className="w-100 p-10 inbox12px-400 text-[#8796AF] text-center">
                  Begin your conversation by broadcasting messages to your
                  customers.
                </span>
              </div>
            )}
            {contactlistLoading && (
              <div
                className={`w-full h-[5vh] flex items-center justify-center`}
              >
                <Loader Width={30} Height={30} loaderBg="white" />
              </div>
            )}
          </InfiniteScroll>
        </div>
      </Skeleton>
    </div>
  );
};

export default CustomerPhoneNumber;
